import React, { useEffect, useMemo, useState } from "react";
import MasterService from "../services/master/MasterService";

const Disposisi = ({idDisposisi}) => {

    let masterService = useMemo(() => new MasterService(), [])
    const [ketDisposisi, setKetDisposisi] = useState('')

    useEffect(() => {
        const getDisposisi = async () => {
            const response = await masterService.getDisposisiById(idDisposisi)
            // console.log(response)
            setKetDisposisi(response.data.ketDisposisi)
        }
        getDisposisi()
    }, [masterService, idDisposisi])

    return (
        <>
            <div>{ketDisposisi}</div>
        </>
    )
}

export default Disposisi